import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useRouteError } from 'react-router-dom';

// מוצג במקום מסך "Unexpected Application Error!" הגולמי של react-router כשקורית
// שגיאת רינדור שלא נתפסה. במקום שהמשתמש יתקע במסך לבן, מוצע לו לרענן.
const RouteErrorBoundary: React.FC = () => {
  const error = useRouteError();
  console.error('Route render error:', error);

  return (
    <Box
      dir="rtl"
      sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        height: '100vh', textAlign: 'center', padding: 3, gap: 2,
      }}
    >
      <Typography variant="h5" fontWeight="bold">
        משהו השתבש
      </Typography>
      <Typography variant="body1" color="text.secondary">
        אירעה שגיאה זמנית בטעינת הדף. נסו לרענן - הפרטים שהזנתם לא נשמרים אוטומטית, ייתכן שתצטרכו להזין אותם שוב.
      </Typography>
      <Button variant="contained" onClick={() => window.location.reload()}>
        רענון הדף
      </Button>
    </Box>
  );
};

export default RouteErrorBoundary;
